"use client";

import { Badge, Button, Flex, Input, Text } from "rizzui";
import { type Table as ReactTableType } from "@tanstack/react-table";
import StatusField from "@core/components/controlled-table/status-field";
import { PiMagnifyingGlassBold, PiTrashDuotone } from "react-icons/pi";
import { transactionTypes } from "../../../../../data/transaction-history";

const transactionTypesOptions = Object.entries(transactionTypes).map(
  ([value, label]) => ({ label, value })
);

const statusOptions = [
  { value: "", label: "All Status" },
  { value: "success", label: "Success" },
  { value: "pending", label: "Pending" },
  { value: "failed", label: "Failed" },
  { value: "cancelled", label: "Cancelled" },
];

const currencyOptions = [
  { value: "NGN", label: "NGN" },
  { value: "USDT", label: "USDT" },
];

interface TableToolbarProps<T extends Record<string, any>> {
  table: ReactTableType<T>;
}

export default function Filters<TData extends Record<string, any>>({
  table,
}: TableToolbarProps<TData>) {
  const isFiltered =
    table.getState().globalFilter || table.getState().columnFilters.length > 0;

  return (
    <Flex
      align="center"
      direction="col"
      className="mt-6 @3xl:flex-row @[62rem]:mt-0"
    >
      <Flex align="center" className="order-2 @3xl:order-1 @3xl:max-w-[360px]">
        {/* <StatusField
          className="w-full"
          placeholder="Select type"
          options={currencyOptions}
          dropdownClassName="!z-10 h-auto"
          getOptionValue={(option) => option.label}
          value={table.getColumn("currencyType")?.getFilterValue() ?? ""}
          onChange={(e) => table.getColumn("type")?.setFilterValue(e)}
        /> */}
        <select
          className="h-9 rounded border px-2 w-[110px]"
          value={table.getColumn("status")?.getFilterValue() ?? ""}
          onChange={(e) =>
            table
              .getColumn("status")
              ?.setFilterValue(e.target.value || undefined)
          }
        >
          {statusOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        {/* <StatusField
          className="w-full"
          placeholder="Currency"
          options={currencyOptions}
          dropdownClassName="!z-10 h-auto"
          getOptionValue={(option) => option.value}
          getOptionDisplayValue={(option) => option.label}
          value={table.getColumn("currencyType")?.getFilterValue() ?? ""}
          onChange={(val) =>
            table.getColumn("currencyType")?.setFilterValue(val)
          }
        /> */}
      </Flex>

      {isFiltered ? (
        <Button
          variant="flat"
          onClick={() => {
            table.resetGlobalFilter();
            table.resetColumnFilters();
          }}
          className="order-3 h-9 w-full bg-gray-200/70 @3xl:order-2 @3xl:w-24"
        >
          <PiTrashDuotone className="me-1.5 size-4" /> Clear
        </Button>
      ) : null}

      <Input
        type="search"
        clearable={true}
        inputClassName="h-[36px]"
        placeholder="Search by customer ID..."
        onClear={() => table.setGlobalFilter("")}
        value={table.getState().globalFilter ?? ""}
        prefix={<PiMagnifyingGlassBold className="size-4" />}
        onChange={(e) => table.setGlobalFilter(e.target.value)}
        className="w-full @3xl:order-3 @3xl:ms-auto @3xl:max-w-72"
      />
    </Flex>
  );
}

function renderOptionDisplayValue(value: string) {
  switch (value.toLowerCase()) {
    case "pending":
      return (
        <div className="flex items-center">
          <Badge color="warning" renderAsDot />
          <Text className="ms-2 font-medium capitalize text-orange-dark">
            {value}
          </Text>
        </div>
      );
    case "complete":
      return (
        <div className="flex items-center">
          <Badge color="success" renderAsDot />
          <Text className="ms-2 font-medium capitalize text-green-dark">
            {value}
          </Text>
        </div>
      );
    case "canceled":
      return (
        <div className="flex items-center">
          <Badge color="danger" renderAsDot />
          <Text className="ms-2 font-medium capitalize text-green-dark">
            {value}
          </Text>
        </div>
      );
    default:
      return (
        <div className="flex items-center">
          <Badge renderAsDot className="bg-gray-400" />
          <Text className="ms-2 font-medium capitalize text-gray-600">
            {value}
          </Text>
        </div>
      );
  }
}
